import styled from 'styled-components';
import { fsDarkBlue } from 'global/colors';

export const ChallengeDescription = styled.div`
  font-size: 11px;
  margin: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

export const CompletionContainer = styled.div`
  font-size: 11px;
  margin-top: 5px;
  text-align: right;
`;

export const SponsorImage = styled.img`
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 4px;
  width: 80px;
  height: 38px;
  background-color: white;
  border-radius: 5px;
`;

export const SelectedCheckbox = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  color: ${fsDarkBlue};
`;
